import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6819yojpbc: FaireBrandEntity = {
  token: "b_6819yojpbc",
  type: "brand",
  name: "Antique Candle Co.®",
  avatarUrl:
    "https://cdn.faire.com/fastly/387a558aa3b513055382c01eff3a17588b5056e11fee46322456d4cab20f87fd.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b926479585be4872b9a18d1c9a52f82c57bbd305e003394957442c951c545dfc.png",
  logoUrl:
    "https://cdn.faire.com/fastly/387a558aa3b513055382c01eff3a17588b5056e11fee46322456d4cab20f87fd.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b926479585be4872b9a18d1c9a52f82c57bbd305e003394957442c951c545dfc.png",
  location: "Lafayette, IN, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 153,
  isTopShop: true,
  isInsider: true,
  description:
    "New candle case options now available:\n- Individual: $19 / candle\n- Case of 6: $18 / candle\n- Case of 12: $17 / candle\n\nOur Mission:\nWe exist to bless homes through candle craft, word, and deed. Each candle is thoughtfully made, carefully packaged, and delivered with kindness, quality, and care - reflecting beauty, goodness, and light in every detail.\n\nOur Story:\nIn 2012, less than a year into my first post-college job at Target, I was overwhelmed. Long hours and frequent weekends, left me feeling exhausted and disconnected. I ultimately stepped away, unsure of what was next.\n\nDuring that season, candle-making started as a personal reset and became a calling. What began in a kitchen grew into a faith-led business rooted in warmth, quality, and care. In 2014, Antique Candle Works was born.\n\nAs the business grew, so did the vision: to create something that felt like home — personal, meaningful, and made with care. With an incredible candle crew, high-quality ingredients, and no shortcuts, that vision came to life. I wanted each candle to be more than a product — something that carries warmth, love, and intention into your home.\n\nToday, my hope is that every candle we send is a blessing to you and your home. As Luke 10:5 says, “Peace to this house.”\n\n— Brittany, Founder & Owner",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:57.250Z",
    importedBy: "entity-db-cli",
  },
};
